import React, { useEffect, useMemo, useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap"; import { toast } from "react-toastify";
import usePermissions from "../../Hooks/usePermissions";
import AppLoader from "../Common/AppLoader";

const DesignationPermissionModal = ({ isOpen, toggle, designation, }) => {
  const { permissions, fetchDesignationPermissions, updateDesignationPermissions, } = usePermissions();
  const [loading,setLoading] = useState(false);
  const [selectedPermissions,setSelectedPermissions] = useState([]);

  useEffect(()=>{
    if(!designation || !isOpen){ return; }
    loadDesignationPermissions();
  },[designation,isOpen]);

  const loadDesignationPermissions = async()=>{
    try{
      setLoading(true);
      const res = await fetchDesignationPermissions( designation._id );
      setSelectedPermissions( res?.permissions || [] );

    }catch(error){
      toast.error(
        error?.message || "Failed to load permissions"
      );
    }finally{
      setLoading(false);
    }

  };

  const groupedPermissions = useMemo(()=>{
    console.log("permissions",permissions);
    const groups = {};
    permissions.forEach((permission)=>{
      const moduleName =
        permission.module || "General";
      if(!groups[moduleName]){
        groups[moduleName] = [];
      }
      groups[moduleName].push(permission);
    });
    return groups;
  },[permissions]);

  const handlePermissionToggle = ( permissionName )=>{
    setSelectedPermissions((prev)=>{
      if(prev.includes(permissionName)){
        return prev.filter(
          (p)=>p !== permissionName
        );
      }
      return [...prev,permissionName];
    });

  };

  const handleSave = async()=>{
    try{
      setLoading(true);
      const res = await updateDesignationPermissions( designation._id, selectedPermissions );
      if(!res.success){
        return toast.error(res.message);
      }
      toast.success( "Permissions Updated" );
      toggle();

    }catch(error){

      toast.error(
        error?.message ||
        "Failed to update permissions"
      );

    }finally{
      setLoading(false);
    }

  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="xl" centered scrollable className="permission-modal" >
      <ModalHeader toggle={toggle}>
        <div className="permission-header">
            <div className="permission-title">
                Permissions : {designation?.title}
            </div>

            <div
                className="permission-select-all"
                onClick={()=>
                setSelectedPermissions(
                    selectedPermissions.length === permissions.length
                    ? []
                    : permissions.map(p=>p.name)
                )
                }
            >
                <label
                className={`crm-checkbox ${
                    selectedPermissions.length === permissions.length &&
                    permissions.length
                    ? "active"
                    : ""
                }`}
                >
                <span />
                </label>

                <span className="fw-semibold">
                Select All
                </span>
            </div>
            </div>
        </ModalHeader>
      <ModalBody style={{ maxHeight:"70vh", overflowY:"auto", background:"#f8f9fa" }} >
        {loading ? (
          <div className="text-center py-5"> <AppLoader /> </div>
        ) : (

          <div className="row">
            {
              Object.entries( groupedPermissions ).map(([module,items])=>(
                <div className="col-md-6 mb-4" key={module} >
                  <div className="bg-white rounded shadow-sm h-100" style={{ border:"1px solid #eef0f2", padding:"16px" }} >
                    <h5 className="mb-3" style={{ color:"#0bb197", fontWeight:700, borderBottom:"1px solid #eef0f2", paddingBottom:"10px" }} > {module} </h5>
                    {
                      items.map((permission)=>(
                        <div key={permission._id} className="d-flex align-items-center justify-content-start py-2" >

                          <label
                            className={`crm-checkbox ${
                              selectedPermissions.includes(
                                permission.name
                              )
                                ? "active"
                                : ""
                            }`}
                            onClick={()=>
                              handlePermissionToggle(
                                permission.name
                              )
                            }
                          >
                            <span />
                          </label>

                          <span
                            className="ms-2"
                            style={{
                              cursor:"pointer",
                            }}
                            onClick={()=>
                              handlePermissionToggle(
                                permission.name
                              )
                            }
                          >
                            {permission.label ||
                              permission.name}
                          </span>

                        </div>
                      ))
                    }

                  </div>

                </div>
              ))
            }

          </div>

        )}

      </ModalBody>

      <ModalFooter style={{ position:"sticky", bottom:0, background:"#fff", borderTop:"1px solid #eef0f2", zIndex:10 }} >

        <Button
          color="light"
          onClick={toggle}
        >
          Cancel
        </Button>

        <Button
          color="primary"
          onClick={handleSave}
          disabled={loading}
        >
          Save Permissions ({selectedPermissions.length})
        </Button>

      </ModalFooter>

    </Modal>
  );
};

export default DesignationPermissionModal;